import { render, staticRenderFns } from "./UserCertificate.vue?vue&type=template&id=125fc44e&scoped=true&"
import script from "./UserCertificate.vue?vue&type=script&lang=js&"
export * from "./UserCertificate.vue?vue&type=script&lang=js&"
import style0 from "./UserCertificate.vue?vue&type=style&index=0&id=125fc44e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125fc44e",
  null
  
)

export default component.exports